import { finish, error } from '../../../modules/customers/actions/remove-freebet-credit';
import { request as getFreebetCredits } from '../../../modules/customers/actions/get-freebet-credits';

import api from '../../../api';

export function request( dispatch, { creditId, customerId, data } ) {
    api.patch( `/user/freebet/${creditId}/remove`, data ).then(
        () => {
            dispatch( finish( customerId, creditId ) );
            dispatch( getFreebetCredits( customerId ) );
        },
        ( { errors } ) => dispatch( error( customerId, creditId, errors ) )
    );
}
